import { useHookstate } from '@hookstate/core';
import { I18n } from 'aws-amplify';
import { DataView } from 'primereact/dataview';
import React, { useEffect, useState } from 'react';
import { allCoffrets, currentCoffret, agreeTemplate } from '../ScrbTools';
import Coffret from './Coffret';
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import classNames from 'classnames';
import { Help } from '../../help/Help';
import { useGlobalHelpState } from '../../../help-context';
import { Button } from 'primereact/button';

const ListeCoffrets = () => {
    const coffrets = useHookstate(allCoffrets);
    const selectedCoffret = useHookstate(currentCoffret);
    const help = useGlobalHelpState();

    const [filters, setFilters] = useState({
        code: '',
        status: '',
        cMarque: '',
        search: ''
    });

    useEffect(() => {
        help.set({ help: Help.global, show: false });
        // eslint-disable-next-line
    }, []);

    const applyFilters = (coffrets) => {
        return JSON.parse(JSON.stringify(coffrets)).filter(coffret => {
            return ((coffret.status === filters.status || filters.status === '') &&
                (coffret.search === '' || coffret.code?.toString().toLowerCase().includes(filters.search.toLowerCase()) ||
                    coffret.cMarque?.toString().toLowerCase().includes(filters.search.toLowerCase()) ||
                    coffret.modele?.toString().toLowerCase().includes(filters.search.toLowerCase()) ||
                    coffret.numeroSerie?.toString().toLowerCase().includes(filters.search.toLowerCase())));
        });
    }

    const filterView = () => {
        return (
            <div>
                <div className='flex flex-column gap-2 w-full pt-2'>
                    <div className="border-100 border-1px border-round p-2 surface-200">
                        {I18n.get("status")}
                    </div>
                    <div className="flex flex-row align-items-center gap-2">
                        <RadioButton value='' checked={filters.status === ''} onChange={(e) => setFilters({ ...filters, status: e.value })} />
                        <label>
                            {I18n.get("all")}
                        </label>
                    </div>
                    <div className="flex flex-row align-items-center gap-2">
                        <RadioButton value={1} checked={filters.status === 1} onChange={(e) => setFilters({ ...filters, status: e.value })} />
                        <label>
                            <i className="fa-solid fa-circle text-green-500 mr-2" />
                            {I18n.get("actif")}
                        </label>
                    </div>
                    <div className="flex flex-row align-items-center gap-2">
                        <RadioButton value={0} checked={filters.status === 0} onChange={(e) => setFilters({ ...filters, status: e.value })} />
                        <label>
                            <i className="fa-solid fa-circle text-red-500 mr-2" />
                            {I18n.get("horsService")}
                        </label>
                    </div>
                </div>
            </div>
        );
    }

    const viewCoffret = (coffret) => {
        let color = coffret.status === 1 ? "green-600" : "red-600";
        if (coffret.status === 1 && (coffret.agreeMazout === 0 || coffret.agreeGaz === 0))
            color = "yellow-600";
        return (
            <div
                className={classNames({
                    "h-full": true,
                    "p-2 surface-0 shadow-1 border-round text-left w-full": true,
                    [`border-left-2 border-${color}`]: true,
                    "hover:surface-100": true,
                })}
            >
                <div className="flex flex-row">
                    <div className="flex flex-column pt-1 pr-3">
                        <i className="fa-light fa-ruler text-2xl"></i>
                    </div>
                    <div className="flex flex-column w-full">
                        <div className='flex flex-row justify-content-between'>
                            <div className="font-semibold text-600">{coffret.code}</div>
                            <div className='flex flex-row  gap-2'>
                                {agreeTemplate(coffret.agreeMazout, coffret.status, "Mazout")}
                                {agreeTemplate(coffret.agreeGaz, coffret.status, "Gaz")}
                            </div>
                        </div>
                        <div className='flex flex-column w-full'>
                            <div className='flex flex-row'><div className='p-card-subtitle pr-2 w-4'>{I18n.get("cMarque")}:</div> {coffret.cMarque}</div>
                            <div className='flex flex-row'><div className='p-card-subtitle pr-2 w-4'>{I18n.get("modele")}:</div> {coffret.modele}</div>
                            <div className='flex flex-row'><div className='p-card-subtitle pr-2 w-4'>{I18n.get("numeroSerie")}:</div> {coffret.numeroSerie}</div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    const productTemplate = (coffrets) => {
        const orderedCoffrets = JSON.parse(JSON.stringify(coffrets)).sort((a, b) => b.status - a.status || a.code.localeCompare(b.code));
        return (
            <div className="flex flex-column">
                {orderedCoffrets.map(coffret =>
                    <button
                        key={coffret.code}
                        className="text-left pb-2 border-none bg-transparent"
                        onClick={() => selectedCoffret.set(JSON.parse(JSON.stringify(coffret)))}
                        style={{ cursor: 'pointer' }}
                    >
                        {viewCoffret(coffret)}
                    </button>
                )}
            </div>
        );
    }

    return (
        <div className="card">
            {(() => {
                if (selectedCoffret.get().id) {
                    return <Coffret />;
                } else {
                    return  (<>
                        <h5>{I18n.get("mesCoffrets")}</h5>
                        <Divider />
                        <div className="flex flex-column lg:flex-row-reverse">
                            <div id="filterBloc" className="w-full lg:w-4 mb-3 lg:mb-0 lg:ml-3 order-1 lg:order-2 dynamic-filters filtrer-bloc">
                                {filterView()}
                            </div>
                            <Divider layout="vertical" className="hidden lg:flex order-2 lg:order-2" />
                            <div id="filterButtonDiv">
                                <Button
                                    icon="pi pi-filter"
                                    label={I18n.get("filtrer")}
                                    text
                                    onClick={() => {
                                        document.getElementById("filterBloc").classList.remove("filtrer-bloc");
                                        document.getElementById("filterButtonDiv").classList.add("filtrer-bloc");
                                    }}
                                    className="text-gray-500 filtrer-button"
                                />
                            </div>
                            <div className="w-full lg:w-9 order-3 lg:order-1">
                                <span className="p-input-icon-left w-full mb-2">
                                    <i className="pi pi-search" style={{ left: '0.5rem' }} />
                                    <InputText
                                        value={filters.search || ''}
                                        placeholder={I18n.get("search")}
                                        onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                                        className="w-full pl-4"
                                    />
                                </span>
                                <DataView
                                    value={applyFilters(coffrets.get())}
                                    listTemplate={productTemplate}
                                    sortField='status'
                                    sortOrder={-1}
                                    emptyMessage={I18n.get("aucunCoffret")}
                                />
                            </div>
                        </div>
                    </>) 
                }
            })()}
        </div>
    )
}

export default ListeCoffrets;
